import { Directive, OnInit, Input } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[appImageLoader]',
  host: {
    '[src]': 'sanitizer.bypassSecurityTrustUrl(imageData)'
  }
})
export class ImageLoaderDirective implements OnInit {

  private static readonly FALLBACK = '/assets/images/no-image.jpeg';

  imageData: any = ImageLoaderDirective.FALLBACK;

  @Input('appImageLoader') imageUrl: string;

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    if (!this.imageUrl) {
      return;
    }
    this.http.get<any>(this.imageUrl).subscribe(
      data => {
        if (data?.mimeType && data?.imageContent) {
          this.imageData = 'data:' + data.mimeType + ';base64,' + data.imageContent;
        } else {
          this.imageData = ImageLoaderDirective.FALLBACK;
        }
      },
      (err: HttpErrorResponse) => {
        console.error('[ImageLoader] erro ao carregar:', this.imageUrl, '— status:', err.status);
        this.imageData = ImageLoaderDirective.FALLBACK;
      }
    );
  }
}
